import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/mfa")({
  component: MfaPage,
});

function MfaPage() {
  // MFA not supported in PHP mode - redirect to home
  return <Navigate to="/" />;
}

